import React from 'react';
import styled from 'styled-components';
import { utils } from '@enso/components';
import theme from '../../../theme';

const BannerSectionContainer = styled.section`
  padding: 0px 24px;
  background-color: ${props => props.theme.color.backgroundWhite};

  @media ${utils.device.laptop} {
    padding: 0px 140px;
  }
`;

const ImageContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-top: 24px;
  margin-left: 0;
  padding-left: 0;
  width: 100%;

  @media ${utils.device.laptop} {
    margin-top: 0;
    margin-left: 0;
    padding-left: 0;
    justify-content: center;
    align-items: flex-start;
  }
`;

const Image = styled.img`
  max-width: 100%;
  height: auto;
  width: 100%;

  @media ${utils.device.laptop} {
    max-width: 800px;
    width: auto;
    height: auto;
  }
`;

BannerSectionContainer.defaultProps = { theme };

const DownloadSection = function() {
  return (
    <BannerSectionContainer>
      <ImageContainer>
        <Image src="/images/banner-1-1.webp" alt="Banner Enso" />
      </ImageContainer>
    </BannerSectionContainer>
  );
};

export default DownloadSection;
